export const ADMIN_TENANT_CODE = "e09b34e755af4f04813491154b265d09";
